module.exports = __webpack_public_path__ + "static/media/Trapézio.53a3ed1b.png";